// hooks/useRateCardById.js
import { useQuery } from "@tanstack/react-query";
import { fetchRateCardById } from "../services/rateCards";

export const useRateCardById = (id) =>
  useQuery({
    queryKey: ["rateCard", id],
    queryFn: () => fetchRateCardById(id),
    enabled: !!id,
  });
